 <template> 
	<div class="window">
        <div class="header"><span v-html="translation.wyniki_rozgrywki"></span>
            <a class="settings" @click="openSettings"><cog-6-tooth-icon class="icon"/></a>
        </div>
        <div class="description-box">
            <div class="congratulation-box mt2x">
                <h2 class="gold" v-html="translation.gratulacje"></h2>
                <img src="../assets/fireworks.gif" class="fireworks" />

                <div class="congratulation-text line1">{{ get__categoryName }}</div>
                <div class="congratulation-flex">
                    <div class="congratulation-text line2">
                        <span>{{ translation.macie_zgodnosc }}:</span>
                        <span>{{ get__summaryPercent }}% ({{ get__summary }}/{{ get__countAnswers*2 }})</span>
                    </div>
                    <div class="progressbar">
                        <div class="filled" :style="summaryPercentWidth"></div>
                    </div>

                    <div class="congratulation-text line2">
                        <span>{{ translation.znasz_grugiego_gracza }}:</span>
                        <span>{{ get__you_percent }}% ({{ get__you }}/{{ get__countAnswers }})</span>
                    </div>
                    <div class="progressbar">
                        <div class="filled" :style="youPercentWidth"></div>
                    </div>
                    <div class="congratulation-text line2">
                        <span><b>{{ opponentName }}</b> {{ translation.zna_ciebie }}:</span>
                        <span>{{ get__opponentPercent }}% ({{ get__opponent }}/{{ get__countAnswers }})</span>
                    </div>
                    <div class="progressbar">
                        <div class="filled" :style="opponentPercentWidth"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="to-bottom">
            <button class="btn btn-all btn-gold"  @click="returnToAnswers" v-html="translation.jak_odpowiadaliscie"></button>
            <button class="btn btn-all btn-return"  @click="returnToCategories" v-html="translation.powrot_do_kategorii"></button>
            <button class="btn btn-all btn-green"  @click="startGame" v-html="translation.graj_dalej"></button>
        </div>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { Cog6ToothIcon } from '@heroicons/vue/24/solid';
import axios from 'axios'

export default {
    name: 'PodsumowaniePoziomu',
    props: {
        language: String
    },
    components: { 
        Cog6ToothIcon,
     
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            theme: localStorage.getItem('theme'),
            get__categoryName:'',
            get__summaryPercent: 0,
            summaryPercentWidth: '',
            get__summary: 0,

            get__you: 0,
            get__you_percent: 0,
            youPercentWidth:'',

            get__opponent: 0,
            get__opponentPercent: 0,
            opponentPercentWidth: '',
            get__opponentName: 0,

            get__countAnswers: 0,
            opponentName: ''
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }
        this.getData()
    },
    methods: {
        startGame() {
            this.$emit('go-start-gry');
        },
        openSettings() {
            this.$emit('open-settings');
        },
        openDescription() {
            this.$emit('open-description');
        },
        backToContinue() {
            this.$emit('back-to-continue');
        },
        returnToCategories() {
            this.$emit('go-to-poziomy');
        },
        returnToAnswers() {
            this.$emit('go-to-nasze-odpowiedzi');
        },
        async getData() {
            this.$emit('show-spinner',true);
            try {
                var data = new FormData();
                data.append('method', 'show-results-summary');
                data.append('device-id', localStorage.getItem('device-id'));
                data.append('hash', localStorage.getItem('game-settings-hash'));
                data.append('lang', localStorage.getItem('language'));

                await axios.post('https://gra.wrealizacji.pl/api3.php?timer='+btoa(new Date().toUTCString()), data)
                .then((res) => {
                        this.get__categoryName = res.data.category_name;
                        this.get__summaryPercent = res.data.summary_percent;
                        this.summaryPercentWidth = 'width: '+res.data.summary_percent+'%';
                        this.get__summary = res.data.summary;

                        this.get__you = res.data.you;
                        this.get__you_percent = res.data.you_percent;
                        this.youPercentWidth = 'width: '+res.data.you_percent+'%';

                        this.get__opponent = res.data.opponent;
                        this.get__opponentPercent = res.data.opponent_percent;
                        this.opponentPercentWidth = 'width: '+res.data.opponent_percent+'%';

                        this.get__opponentName = res.data.opponent_name;
                        this.get__countAnswers = res.data.count;
                        this.opponentName = res.data.user2;

                        let actual = JSON.parse(localStorage.getItem('levels-'+localStorage.getItem('klucz')));
                        actual.status = 2;
                        actual.wynik = res.data.summary_percent;
                        actual.zgodnosc = res.data.summary;
                        actual.odpowiedzi = res.data.answers;
                        localStorage.setItem('levels-'+localStorage.getItem('klucz'), JSON.stringify(actual));
                        this.$emit('show-spinner',false);
                }).catch((error) => {
                    console.log(error);
                    this.komunikatPolaczenia = this.translation.blad_polaczenia;
                    this.$emit('show-spinner',false);
                });
            } catch (err) {
                setTimeout(function () { 
                    this.getData() 
                }.bind(this), 1000) 
            }
        }
    },
    watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
    },
}
</script>

<style scoped>
.fireworks {
    position: absolute;
    width: 100%;
    height: 80vw;
    z-index: 200;
    top: 0;
    left: 0;
}
.gold {
    text-transform:uppercase;
    color: var(--bs-gold);
    letter-spacing: 1.5px;
    font-size: 1.7em;
    margin-top:80px;
}
.to-bottom {
    position: fixed;
    left:0;
    right:0;
    bottom:10px;
    padding: 0 20px;
}
a.back-screen {
    position:fixed;
    left:10px;
    bottom:10px;
    color: var(--bs-button-text);
}
a.back-screen svg {
    width: 15px;
    margin-top:5px;
}
.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}
a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}
a.description svg {
    width: 25px;
    position:absolute;
    right: 60px;
    top:12px;
}
.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 200px;
    overflow: auto;
}
.btn.btn-all {
    font-size: 1em;
    height: 3em;
    width: 100%;
    border-radius: 10px;
    margin: 5px auto;
    font-weight:bold;
    position: relative;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}
.btn-green {
    background-color: var(--bs-gradient-to);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-green::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    animation: chevronPulse 1s infinite;
    transition: transform 0.3s ease;
}

.btn-gold {
    background-color: var(--bs-gold);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-gold::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    transition: transform 0.3s ease;
}

.btn-return {
    background-color: transparent;
    border:1px solid var(--bs-gradient-to);
    color: var(--bs-button-text);
    position: relative;
    border-color:var(--bs-button-text);
}
.btn-return::after {
    content: '';
    position: absolute;
    left: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-button-text);
    border-bottom: 2px solid var(--bs-button-text);
    transform: translateY(-50%) rotate(135deg);
    transition: transform 0.3s ease;
}

@keyframes chevronPulse {
    0%, 100% {
        transform: translateY(-50%) rotate(-45deg) translateX(0);
        opacity: 1;
    }
    50% {
        transform: translateY(-3px) rotate(-45deg) translateX(5px);
        opacity: 0.5;
    }
}
.mt2x {
    margin: 2em 0 0.5em;
}
.congratulation-box {
    background: var(--bs-box-background);
    border: var(--bs-settings-button-border);
    border-radius: 8px;
    padding: 20px 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;

}
.congratulation-box::before {
    content: '🏆';
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 80px;
    opacity: 0.85;
    transform: rotate(15deg);
}
.congratulation-box::after {
    content: '🏆';
    position: absolute;
    top: 0;
    left: 10px;
    font-size: 80px;
    opacity: 0.85;
    transform: rotate(-15deg);
}
.congratulation-text {
    position: relative;
    z-index: 1;
    color: var(--bs-settings-button-color-active);
    line-height: 1.5;
    margin: 0;
}
.congratulation-text.line1 {
    font-weight: 600;
    color:var(--bs-button-text);
    display:block;
    text-align:left;
    border-bottom:1px solid var(--bs-button-text);
    margin-bottom:2em;
}

.congratulation-text.line2 {
    color:var(--bs-button-text);
    display:block;
    text-align:left;
    border-bottom:1px solid #aaa;
}
.line2 {
    display: flex !important;
    padding: 5px 0 3px;
    
}
.line2 span:first-child {
  margin-right: auto;
}

.line2 span:last-child {
  white-space: nowrap;
}

.progressbar {
    height: 3px;
    position: relative;    margin-bottom:0.5em;

}

.progressbar .filled {
    background-color: var(--bs-gold);
    height:100%;
    position:absolute;
    left:0;
    top:0;
    bottom:0;
}
</style>
